export const productCategories = [
  { id: 'all', label: 'All' },
  { id: 'fresh', label: 'Fresh Flowers' },
  { id: 'dried', label: 'Dried Flowers' },
  { id: 'objects', label: 'Objects' },
];

// NOTE: the original sources for bleached-palm and vessel-no-7 were byte-identical to afterglow,
// so they share the same optimized file until dedicated photography is supplied.
export const products = [
  {
    id: 'afterglow',
    no: '01',
    name: 'Afterglow',
    price: 86,
    category: 'fresh',
    note: 'Apricot roses, amber ranunculus and copper beech in a hand-thrown stoneware vessel.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-arr-afterglow.webp',
  },
  {
    id: 'field-notes',
    no: '02',
    name: 'Field Notes',
    price: 74,
    category: 'dried',
    note: 'Wild grasses, scabiosa pods and loose meadow stems in smoked amber glass.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-arr-fieldnotes.webp',
  },
  {
    id: 'still-life-03',
    no: '03',
    name: 'Still Life No. 03',
    price: 98,
    category: 'fresh',
    note: 'Deep burgundy dahlias, black calla and plum foliage, low and asymmetric.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-arr-stilllife.webp',
  },
  {
    id: 'soft-geometry',
    no: '04',
    name: 'Soft Geometry',
    price: 92,
    category: 'fresh',
    note: 'White anthurium, green allium spheres and folded aspidistra in a sculpted vase.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/587ec097-3f6f-459e-9fda-bbab1d2fb4a2_ff-arr-softgeometry.webp',
  },
  {
    id: 'bleached-palm',
    no: '05',
    name: 'Bleached Palm',
    price: 68,
    category: 'dried',
    note: 'Sun-bleached palm spear, lunaria and pampas plumes. Keeps its shape for seasons.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/62e47e39-3b48-4d86-923a-6c98e89446cb_ff-shop-bleached-palm.webp',
  },
  {
    id: 'vessel-no-7',
    no: '06',
    name: 'Vessel No. 7',
    price: 58,
    category: 'objects',
    note: 'Hand-thrown stoneware bud vase with a raw speckled glaze. Made in small batches.',
    image: 'https://public.readdy.ai/ai/img_res/sandbox/0a9d2030d78e6980171043cc5a230587/62e47e39-3b48-4d86-923a-6c98e89446cb_ff-shop-vessel-no7.webp',
  },
];